import { allCarCatalogsRequest } from "@/utils/requests/laximo/allCarCatalogsRequest";
import { useContext, useEffect } from "react";
import { SearchVehicleByParamsDataContext } from "../SearchVehicleByParamsDataProvider";
import { LoadingData, SearchVehicleByParamsDataContextType, SetSearchVehicleByParamsDataContextType, ShowDataIndicators } from "../types";

/**
 * Загрузка каталогов автомобиля
 * @param {React.ReactNode} children - Дочерние компоненты
 * @returns {React.ReactNode}
 */
export const LoadCarCatalog = ({ children }: { children: React.ReactNode }) => {
    const { brand, catalogSsd, setCatalogInfo, setShowCatalogInfo, setIsLoading, setError } = useContext(SearchVehicleByParamsDataContext) as SearchVehicleByParamsDataContextType & SetSearchVehicleByParamsDataContextType & LoadingData & ShowDataIndicators;

    useEffect(() => {
        if (brand) {
            setIsLoading(true);
            allCarCatalogsRequest(brand, catalogSsd)
                .then(data => {
                    setCatalogInfo(data);
                    setShowCatalogInfo(true);
                })
                .catch(error => {
                    setError(error.message);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [brand, catalogSsd]);

    return children;
}